'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { Heading } from '../ui/heading';
import { Paragraph } from '../ui/paragraph';
import { Button } from '../ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function RegisterSuccess({ inDialog }: { inDialog?: boolean }) {
  const { t } = useTranslations();

  return (
    <div
      className={cn(
        'flex w-full flex-col items-center justify-center gap-8',
        !inDialog && 'pb-12 pt-48 sm:pb-16 sm:pt-52 lg:pt-64',
      )}
    >
      <div className="flex w-full flex-col items-center justify-center gap-6">
        <Image
          src={'/images/icons/green-check.svg'}
          alt={t('text3401')}
          height={56}
          width={56}
          className="shrink-0 object-contain"
        />
        <Heading
          title={t('text3401')}
          className={{
            container: 'w-full items-center justify-center text-center',
            title: 'uppercase',
          }}
          tag="h4"
        />
        <Paragraph className="w-full text-center">{t('text3402')}</Paragraph>
      </div>
      <div className="flex w-full flex-col items-center justify-center gap-2 sm:flex-row">
        <Button asChild variant={'dark'} className="w-full sm:w-fit">
          <Link prefetch={false} href={ROUTES.HOME()}>
            {t('text2379')}
          </Link>
        </Button>
        <Button asChild className="w-full sm:w-fit">
          <Link prefetch={false} href={ROUTES.PROFILE()}>
            {t('text1134')}
          </Link>
        </Button>
      </div>
    </div>
  );
}
